"use client"

import { motion } from "framer-motion"
import { Card } from "@/components/ui/card"
import { Button } from "@/components/ui/button"
import { Package, Truck, Globe, Briefcase, Heart } from "lucide-react"
import { ArrowRight } from "lucide-react"
import Link from "next/link"
import {serviceDetails} from '@/lib/services-data'

export function Services() {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
      },
    },
  }

  const itemVariants = {
    hidden: { opacity: 0, scale: 0.9 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: { duration: 0.5 },
    },
  }

  return (
    <motion.section
      className="pb-20 sm:pb-32 bg-gradient-to-b from-slate-50 to-white"
      variants={containerVariants}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, margin: "-100px" }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-16">
        <motion.div className="text-center mb-16" variants={itemVariants}>
          <h2 className="text-4xl sm:text-5xl font-bold text-foreground mb-4">Our Core Services</h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Comprehensive relocation solutions tailored to your specific needs
          </p>
        </motion.div>

        <motion.div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" variants={containerVariants}>
          {serviceDetails.map((service, index) => {
            const Icon = service.icon
            return (
              <motion.div
                key={index}
                variants={itemVariants}
              >
                <Link href={`/services/${service.slug}`} className="block h-full">
                  <Card className="p-8 h-full bg-gradient-to-br from-white to-slate-50 border-2 border-primary/10 hover:border-primary/30 hover:shadow-2xl transition-all overflow-hidden group cursor-pointer hover:scale-105">
                    <div
                      className={`absolute inset-0 bg-gradient-to-br ${service.color} opacity-0 group-hover:opacity-5 transition-opacity duration-300`}
                    />
                    <div className="relative z-10">
                      <motion.div
                        className={`w-16 h-16 rounded-2xl bg-gradient-to-br ${service.color} flex items-center justify-center mb-6 shadow-lg`}
                        whileHover={{ rotate: 12, scale: 1.1 }}
                      >
                        <Icon size={32} className="text-white" />
                      </motion.div>
                      <h3 className="text-xl font-bold text-foreground mb-3 group-hover:text-primary transition-colors">
                        {service.title}
                      </h3>
                      <p className="text-muted-foreground leading-relaxed mb-6">{service.shortDescription}</p>
                      <motion.div whileHover={{ x: 4 }} transition={{ duration: 0.2 }}>
                        <Button
                          variant="ghost"
                          className="text-primary hover:bg-primary/10 p-0 h-auto font-semibold gap-2 group/btn pointer-events-none"
                        >
                          Learn More
                          <ArrowRight size={16} className="group-hover/btn:translate-x-1 transition-transform" />
                        </Button>
                      </motion.div>
                    </div>
                  </Card>
                </Link>
              </motion.div>
            )
          })}
        </motion.div>
      </div>
    </motion.section>
  )
}
